//'use strict';
//
import d3 from 'd3';
// require('./bar-chart-horizontal-single.D3.js');



export default class BarHorizontalController{

    constructor(
        $scope,
        futureCitiesService
    ){

        let vm = this;

        vm.pageTitle = "Bar Horizontal";
        vm.futureCitiesService = futureCitiesService;

    }




}

BarHorizontalController.$inject = [
    '$scope',
    'futureCitiesService'
];



// WEBPACK FOOTER //
// ./src/app/emxd-charts/bar-horizontal/bar-horizontal.controller.js